import { FormControlAmount, IFormControlAmountProps } from '../../amount';

export type OriginalAmountInputProps = IFormControlAmountProps;
export { FormControlAmount as OriginalAmountInput };
